import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { MaterialType } from "@app/strain/materials/models/material-type.enum";
import { SampleBoardMaterialRecipeItem } from "@app/strain/sample-boards/models/sample-board-material-recipe-item.model";

@Component({
    selector: 'app-sample-board-recipe-item',
    templateUrl: './sample-board-recipe-item.component.html',
    styleUrls: ['./sample-board-recipe-item.component.scss']
})
export class SampleBoardRecipeItemComponent {
    @Input() item: SampleBoardMaterialRecipeItem;
    @Input() index: number;
    @Output() openMaterial = new EventEmitter<SampleBoardMaterialRecipeItem>();

    @HostBinding('class')
    get hostClasses(): string {
        return 'recipe-item mode-recipe';
    }

    onOpenMaterial(event: MouseEvent): void {
        event.stopPropagation();
        this.openMaterial.emit(this.item);
    }

    resolveMaterialTypeIcon(type?: string | MaterialType): string {
        switch (String(type)) {
            case String(MaterialType.PCB):
                return 'fa-microchip';
            case String(MaterialType.Connector):
                return 'fa-plug';
            case String(MaterialType.Housing):
                return 'fa-cube';
            case String(MaterialType.Cover):
                return 'fa-clone';
            case String(MaterialType.Panel):
                return 'fa-th-large';
            default:
                return 'fa-tag';
        }
    }

    resolveMaterialTypeName(type?: string | MaterialType): string {
        switch (String(type)) {
            case String(MaterialType.PCB):
                return 'PCB';
            case String(MaterialType.Connector):
                return 'Connector';
            case String(MaterialType.Housing):
                return 'Housing';
            case String(MaterialType.Cover):
                return 'Cover';
            case String(MaterialType.Panel):
                return 'Panel';
            default:
                return type ? String(type) : 'Material';
        }
    }
}
